import { Navigate, Route, useLocation, useParams } from 'react-router-dom';
import { LEGACY_REDIRECTS, buildRedirect } from '../lib/kyckConnect/legacyRoutes';

// THE OLD ROUTES THE KYCKCONNECT RESTRUCTURE MOVED (redesign Phase 1). Each redirects to its new home with the query string
// preserved, so bookmarks, Slack alerts and emailed links keep working. The table is src/lib/kyckConnect/legacyRoutes.ts (pure,
// tested). The conference booth page /lead-bot/live/:botId is NOT here: it does not move.

function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const { search } = useLocation();
  return <Navigate to={buildRedirect(to, params, search)} replace />;
}

export const legacyRedirectRoutes = LEGACY_REDIRECTS.map((r) => <Route key={r.from} path={r.from} element={<LegacyRedirect to={r.to} />} />);
